import { ACTIVATION_SELECT_ENABLE, ACTIVATION_ENABLE } from "./ItemMyStatBase"


export const LEAGUE_TYPE_SEASON = 1
export const LEAGUE_TYPE_CUP = 2
export const LEAGUE_TYPE_PERFORMANCE = 3

export const LEAGUE_TYPE_SEASON_STRING = "季賽"
export const LEAGUE_TYPE_CUP_STRING = "盃賽"
export const LEAGUE_TYPE_PERFORMANCE_STRING = "表演賽"


export const league_type_attr = [
    { "val": LEAGUE_TYPE_SEASON, "name": LEAGUE_TYPE_SEASON_STRING },
    { "val": LEAGUE_TYPE_CUP, "name": LEAGUE_TYPE_CUP_STRING },
    { "val": LEAGUE_TYPE_PERFORMANCE, "name": LEAGUE_TYPE_PERFORMANCE_STRING }
]

export function get_league_type_string(val){
    switch(val){
        case LEAGUE_TYPE_SEASON:
            return LEAGUE_TYPE_SEASON_STRING
        case LEAGUE_TYPE_CUP:
            return LEAGUE_TYPE_CUP_STRING
        case LEAGUE_TYPE_PERFORMANCE:
            return LEAGUE_TYPE_PERFORMANCE_STRING
        default:
            return ""
    }
}

export class ReqLeagueList {
    constructor({ start, limit, league_name = "", league_activation = ACTIVATION_SELECT_ENABLE }) {
        this.start = start
        this.limit = limit
        this.league_name = league_name
        this.league_activation = league_activation
    }

    fromJson(jsonData) {
        this.start = jsonData.start || 0
        this.limit = jsonData.limit || 10
        this.league_name = jsonData.league_name || ""
        this.league_activation = jsonData.league_activation || ACTIVATION_SELECT_ENABLE
    }

    get_league_activation() {
        return this.league_activation === 1 ? true : false
    }
}

export class ReqLeagueDetail {
    constructor({league_id}){
        this.league_id = league_id
    }
}

export class RespLeague {
    constructor({league_id, league_name, league_name_eng, league_type, league_activation, league_last_change, league_note, logo_league, logo_league_auth, logo_league_date}){
        this.league_id = league_id 
        this.league_name = league_name 
        this.league_name_eng = league_name_eng 
        this.league_type = league_type 
        this.league_activation = league_activation 
        this.league_last_change = league_last_change 
        this.league_note = league_note
        this.logo_league = logo_league 
        this.logo_league_auth = logo_league_auth
        this.logo_league_date = logo_league_date
    }

    fromJson(jsonData){
        this.id = jsonData._id
        this.league_id = jsonData.league_id 
        this.league_name = jsonData.league_name 
        this.league_name_eng = jsonData.league_name_eng 
        this.league_type = jsonData.league_type 
        this.team_acount = jsonData.team_acount || 0
        this.league_activation = jsonData.league_activation
        this.league_last_change = jsonData.league_last_change 
        this.league_note = jsonData.league_note
        this.logo_league = jsonData.logo_league 
        this.logo_league_auth = jsonData.logo_league_auth
        this.logo_league_date = jsonData.logo_league_date
    }
}